
@if (currentDay()) {
  <section class="route-day__container">
    <p
      class="ci-heading-h5-s-bold route-day__title"
      [textContent]="currentDay()"
    ></p>
  </section>
}
